/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierProperties
 */
export interface CarrierProperties {
  /**
   *
   * @type {string}
   * @memberof CarrierProperties
   */
  carrierPropertiesId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierProperties
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierProperties
   */
  invoiceAuditAgent?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierProperties
   */
  bannerMessageTitle?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierProperties
   */
  bannerMessageDescription?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierProperties
   */
  bannerMessageLastEditedBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierProperties
   */
  bannerMessageLastEditedAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the CarrierProperties interface.
 */
export function instanceOfCarrierProperties(
  value: object,
): value is CarrierProperties {
  return true;
}

export function CarrierPropertiesFromJSON(json: any): CarrierProperties {
  return CarrierPropertiesFromJSONTyped(json, false);
}

export function CarrierPropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierProperties {
  if (json == null) {
    return json;
  }
  return {
    carrierPropertiesId:
      json["carrierPropertiesId"] == null
        ? undefined
        : json["carrierPropertiesId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    invoiceAuditAgent:
      json["invoiceAuditAgent"] == null ? undefined : json["invoiceAuditAgent"],
    bannerMessageTitle:
      json["bannerMessageTitle"] == null
        ? undefined
        : json["bannerMessageTitle"],
    bannerMessageDescription:
      json["bannerMessageDescription"] == null
        ? undefined
        : json["bannerMessageDescription"],
    bannerMessageLastEditedBy:
      json["bannerMessageLastEditedBy"] == null
        ? undefined
        : json["bannerMessageLastEditedBy"],
    bannerMessageLastEditedAt:
      json["bannerMessageLastEditedAt"] == null
        ? undefined
        : json["bannerMessageLastEditedAt"],
  };
}

export function CarrierPropertiesToJSON(json: any): CarrierProperties {
  return CarrierPropertiesToJSONTyped(json, false);
}

export function CarrierPropertiesToJSONTyped(
  value?: CarrierProperties | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierPropertiesId: value["carrierPropertiesId"],
    carrierIdentifier: value["carrierIdentifier"],
    invoiceAuditAgent: value["invoiceAuditAgent"],
    bannerMessageTitle: value["bannerMessageTitle"],
    bannerMessageDescription: value["bannerMessageDescription"],
    bannerMessageLastEditedBy: value["bannerMessageLastEditedBy"],
    bannerMessageLastEditedAt: value["bannerMessageLastEditedAt"],
  };
}
